import { OrganizationSettings } from '../pages';
import { IPage } from '../pages/types';
import { WithRouteData } from '../render-routes';

export const OrganizationPage = (props: IPage) => (
  <OrganizationSettings {...props} />
);

export default WithRouteData(OrganizationPage);
